import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { OffsetPageDTO } from "@/shared/contracts/base";

export type WorkshopEventDTO = {
  id: string;
  slug: string;
  title: string;
  status: "draft" | "open" | "closed";
  opensAt: string | null;
  closesAt: string | null;
};

export type WorkshopRegistrationDTO = {
  id: string;
  eventId: string;
  fullName: string;
  nickname: string | null;
  phoneNumber: string;
  status: string;
  submittedAt: string;
  sessionLabels?: string[];
};

export const workshopRegistrationsApi = {
  listEvents: () =>
    fetcher.get<{ items: WorkshopEventDTO[] }>(
      `${config.apiUrl}/workshop-registrations/events`,
    ),

  listRegistrations: (query: Record<string, string | number | undefined>) => {
    const url = new URL(`${config.apiUrl}/workshop-registrations/registrations`);
    url.searchParams.set("limit", String(query.limit ?? 50));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.eventId) url.searchParams.set("eventId", String(query.eventId));
    if (query.status) url.searchParams.set("status", String(query.status));
    if (query.search) url.searchParams.set("search", String(query.search));
    return fetcher.get<OffsetPageDTO<WorkshopRegistrationDTO>>(url.toString());
  },

  updateRegistration: (id: string, body: { status?: string; adminNotes?: string | null }) =>
    fetcher.patch<WorkshopRegistrationDTO>(
      `${config.apiUrl}/workshop-registrations/registrations/${id}`,
      body,
    ),
};
